// XXX TODO FIXME autogen this from site.go; lotsa dupe data
let current_site_id;
let short_site_id;
let default_currency;
let site_base;
let site_name;
let default_market;
if (IS_AKTIEDYSTEN_DK) {
	current_site_id = "AKTIEDYSTEN_DK";
	short_site_id = "AD";
	default_currency = "DKK";
	site_base = "aktiedysten.dk";
	site_name = "Aktiedysten"
    default_market = "DK_STOCK";
} else if (IS_AKTIEKAMPEN_SE) {
	current_site_id = "AKTIEKAMPEN_SE";
	short_site_id = "AK";
	default_currency = "SEK";
	site_base = "aktiekampen.se";
	site_name = "Aktiekampen"
    default_market = "SE_STOCK";
} else if (IS_INVESTSPIEL_DE) {
	current_site_id = "INVESTSPIEL_DE";
	short_site_id = "IV";
	default_currency = "EUR";
	site_base = "investspiel.de";
	site_name = "Investspiel"
    default_market = "DE_STOCK";
} else if (IS_TRADERR_COM) {
	current_site_id = "TRADERR_COM";
	short_site_id = "TR";
	default_currency = "USD";
	site_base = "traderr.com";
	site_name = "Traderr"
    default_market = "US_STOCK";
}

export {
	current_site_id,
	short_site_id,
	default_currency,
	site_base,
	site_name,
    default_market,
}



// WEBPACK FOOTER //
// ./src/Site.js